import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed} from "vue";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const snackBar = computed(() => store.getters['snackBarModule/snackBar']);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_v_snackbar, {
      color: snackBar.value.color,
      modelValue: snackBar.value.show,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((snackBar.value.show) = $event)),
      text: snackBar.value.message,
      location: "top",
      timeout: 2000
    }, null, 8, ["color", "modelValue", "text"])
  ], 64))
}
}

})